import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
/* eslint-disable react/prefer-stateless-function */


var ToggleButtonGroup = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ToggleButtonGroup, _Component);

  function ToggleButtonGroup(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.getChildren = function getChildren(children) {
    var _this2 = this;

    var _this$props = this.props,
        value = _this$props.value,
        disabled = _this$props.disabled,
        alpha = _this$props.alpha;
    return React.Children.map(children, function (child, index) {
      var childProps = child.props;
      return React.cloneElement(child, {
        index: index,
        disabled: disabled,
        alpha: alpha,
        active: childProps.value === value,
        onClick: _this2.handleClick
      });
    });
  };

  _proto.handleClick = function handleClick(event, value) {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        previousValue = _this$props2.value;
    onChange(event, value, previousValue);
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        element = _this$props3.element,
        children = _this$props3.children,
        label = _this$props3.label,
        className = _this$props3.className,
        alpha = _this$props3.alpha,
        inline = _this$props3.inline;
    var Element = element;
    return /*#__PURE__*/React.createElement(Element, {
      className: classnames(className, 'ln-c-toggle-button-group', alpha && 'ln-c-toggle-button-group--alpha', inline && 'ln-c-toggle-button-group--inline'),
      role: "group",
      "aria-label": label
    }, this.getChildren(children));
  };

  return ToggleButtonGroup;
}(Component);

ToggleButtonGroup.displayName = 'ToggleButtonGroup';
ToggleButtonGroup.propTypes = {
  /** Allows the top-level element to be customized */
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),

  /** Array of `ToggleButton` components */
  children: PropTypes.node.isRequired,

  /** `aria-label` applied to the toggle button group (useful for screen readers) */
  label: PropTypes.node,

  /** The value of the item that is currently active / selected */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** On change handler */
  onChange: PropTypes.func.isRequired,

  /** Additional classes to be added to the top-level element */
  className: PropTypes.string,

  /** Displays the alpha styling variant */
  alpha: PropTypes.bool,

  /** Display using inline flex (sized to fit contents) */
  inline: PropTypes.bool,

  /** Disables all toggle button items */
  disabled: PropTypes.bool
};
ToggleButtonGroup.defaultProps = {
  element: 'div',
  label: undefined,
  value: undefined,
  className: undefined,
  alpha: false,
  inline: false,
  disabled: false
};
/**
 * @see [`ToggleButtonGroup`](#/Components/Button?id=togglebuttongroup) for a demo of toggle buttons used in a group.
 */

var ToggleButton = function ToggleButton(_ref) {
  var element = _ref.element,
      children = _ref.children,
      value = _ref.value,
      className = _ref.className,
      alpha = _ref.alpha,
      active = _ref.active,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      role = _ref.role,
      rest = _objectWithoutPropertiesLoose(_ref, ["element", "children", "value", "className", "alpha", "active", "disabled", "onClick", "role"]);

  var Item = element;
  var props = Object.assign({}, rest, {
    className: classnames(className, 'ln-c-toggle-button', alpha && 'ln-c-toggle-button--alpha', active && 'is-active', disabled && 'is-disabled'),
    role: role,
    onClick: onClick && function (event) {
      return onClick(event, value);
    },
    'aria-pressed': active,
    'aria-disabled': disabled
  });

  if (Item === 'button') {
    props.disabled = disabled;
    props.type = 'button';
  }

  return /*#__PURE__*/React.createElement(Item, props, children);
};

ToggleButton.displayName = 'ToggleButton';
ToggleButton.propTypes = {
  /** Allows the top-level element to be customized */
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),

  /** Content displayed by the item */
  children: PropTypes.node.isRequired,

  /** Value of the button when active */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Additional classes to be added to the top-level element */
  className: PropTypes.string,

  /** Displays the alpha styling variant */
  alpha: PropTypes.bool,

  /** Is active / selected */
  active: PropTypes.bool,

  /** Is disabled */
  disabled: PropTypes.bool,

  /** On click handler */
  onClick: PropTypes.func,

  /** `role` attribute */
  role: PropTypes.string
};
ToggleButton.defaultProps = {
  element: 'button',
  className: undefined,
  alpha: false,
  active: false,
  disabled: false,
  onClick: undefined,
  role: undefined
}; // Toggle Button

export { ToggleButtonGroup, ToggleButton };